import { Injectable } from '@angular/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { AuthService, LOCAL_STORAGE_AUTH_TOKEN_KEY, LOCAL_STORAGE_CURRENT_USER_KEY } from './auth.service';
import { AccessibilityService } from './accessibility.service';
import { ChatlioService } from './chatlio.service';
import { NotificationsService } from './notifications.service';
import { PusherService } from './pusher.service';
import { RidesPusherService } from './rides-pusher.service';
import { NewVersionCheckerService } from './new-version-checker.service';

export const DEFAULT_URL = 'book';

@Injectable({
  providedIn: 'root',
})
export class InitAppService {
  constructor(
    private readonly authService: AuthService,
    private readonly chatlioService: ChatlioService,
    private readonly pusherService: PusherService,
    private readonly notificationService: NotificationsService,
    private readonly ridesPusherService: RidesPusherService,
    private readonly accesssibilityService: AccessibilityService,
    private readonly newVersionCheckerService: NewVersionCheckerService
  ) {}

  async initApp() {
    await SplashScreen.show({ autoHide: false });
    try {
      this.newVersionCheckerService.startChecking();
      const accessInfo = JSON.parse(localStorage.getItem(LOCAL_STORAGE_AUTH_TOKEN_KEY));
      if (!accessInfo) return;
      console.log('initApp');
      this.authService.currentUser = JSON.parse(localStorage.getItem(LOCAL_STORAGE_CURRENT_USER_KEY));
      await this.authService.getCurrentUserInfo();
      this.initServices();
    } finally {
      setTimeout(() => {
        SplashScreen.hide();
      }, 2000);
    }
  }

  initServices() {
    this.chatlioService.init();
    // this.oneSignalService.init();
    this.pusherService.init();
    this.notificationService.subscribeToNotificationsPusherChannel();
    this.notificationService.getNotifications();
    this.ridesPusherService.subscribeToRidesPusherChannel();
    const currentUser = this.authService.currentUser;
    if (currentUser?.account?.settings.accessibility_enabled) {
      this.accesssibilityService.init();
    }
  }

  closeServices(isLogout = false) {
    if (isLogout) {
      this.chatlioService.close();
    }
    // this.oneSignalService.close();
    this.pusherService.close();
    this.notificationService.unsubscribeToNotificationsPusherChannel();
    this.ridesPusherService.unsubscribeToRidesPusherChannel();
  }
}
